export const ARTIST = "I'm an Artist";
export const FAN = "I'm a Fan";
